import { isAfter } from 'date-fns';
import * as _ from 'lodash';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';

export class Utilities {
    public static readonly LISTENERS_DEBOUNCE_TIME = 400;
    public static readonly FORM_STATUS_SETTLE_MS = Utilities.LISTENERS_DEBOUNCE_TIME * 4; // 1600ms
    public static readonly STORE_QUIET_MS = 2100; // > FORM_STATUS_SETTLE_MS + LISTENERS_DEBOUNCE_TIME

    static isNullOrEmptyString(string: string): boolean {
        return string === null || string === '' || _.isNil(string);
    }

    /* Converte una stringa in un numero preservando il null (non convertendolo in 0). */
    static convertStringToNumber(string: string): number {
        if (this.isNullOrEmptyString(string)) {
            return null;
        } else {
            return +string;
        }
    }

    /* Verifica che le date in input siano valorizzate, coerenti e che sia la prima conseguente alla seconda
     * RICORDA: Il valore delle date si rifà alla specifica ISO 8601 (tipo Date),
     * le stringhe in input quindi devono rispettare tale standard per essere elaborate correttamente. */
    static isDateAfter(date: string, dateToCompare: string): boolean {
        /* condizione di uscita necessaria per prevenire cast esotici */
        if (this.isNullOrEmptyString(date) || this.isNullOrEmptyString(dateToCompare)) {
            return null;
        }
        /* ********************************************************** */
        let dateCasted: Date = new Date(date);
        let dateToCompareCasted: Date = new Date(dateToCompare);
        if (isNaN(dateCasted.getMilliseconds()) || isNaN(dateToCompareCasted.getMilliseconds())) {
            console.error('Errore nel casting di una string in una Date in isDateAfter().');
            return null;
        }
        return isAfter(dateCasted, dateToCompareCasted);
    }

    static isNullOrEmptyArray(array: any[]): boolean {
        return array === null || array.length === 0;
    }

    /* Divide il dividendo per il divisore, e ritorna null se la divisione non è definita */
    static safeDivide(dividendo: string, divisore: string): string {
        if (isNilOrEmpty(dividendo) || isNilOrEmpty(divisore)) {
            return null;
        }

        const result = toNum(dividendo) / toNum(divisore);
        return result.toLocaleString('it-IT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    /* Somma i due addendi, e ritorna null se la somma non è definita, ovvero se almeno uno dei due addendi è null */
    static safeSum(addendo1: string, addendo2: string): string {
        if (Utilities.isNullOrEmptyString(addendo1) || Utilities.isNullOrEmptyString(addendo2)) {
            return null;
        } else {
            let result = Utilities.convertStringToNumber(addendo1) + Utilities.convertStringToNumber(addendo2);
            return result.toString();
        }
    }
}
